const MAX_BOOKING_TIMESPAN_IN_WEEKS = 12;
export default MAX_BOOKING_TIMESPAN_IN_WEEKS;
